/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Survey = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 20">
      <g>
        <path d="M15,2.5 L12.71,2.5 L10.85,0.65 C10.7597197,0.552861654 10.6326039,0.498383452 10.5,0.49996502 L5.5,0.49996502 C5.36739614,0.498383452 5.24028033,0.552861654 5.15,0.65 L3.29,2.5 L1,2.5 C0.723857625,2.5 0.5,2.72385763 0.5,3 L0.5,19 C0.5,19.2761424 0.723857625,19.5 1,19.5 L15,19.5 C15.2761424,19.5 15.5,19.2761424 15.5,19 L15.5,3 C15.5,2.72385763 15.2761424,2.5 15,2.5 Z M5.71,1.5 L10.29,1.5 L11.54,2.75 L10.29,4 L5.71,4 L4.46,2.75 L5.71,1.5 Z M14.5,18.5 L1.5,18.5 L1.5,3.5 L3.79,3.5 L5.15,4.85 C5.24028033,4.94713835 5.36739614,5.00161655 5.5,5 L10.5,5 C10.6326039,5.00161655 10.7597197,4.94713835 10.85,4.85 L12.21,3.5 L14.5,3.5 L14.5,18.5 Z" />
        <path d="M10.65,8.81 L6.65,12.81 L4.85,11 C4.75926667,10.9033228 4.63258591,10.8484814 4.5,10.8484814 C4.36741409,10.8484814 4.24073333,10.9033228 4.15,11 C4.05534367,11.0938833 4.00210084,11.2216812 4.00210084,11.355 C4.00210084,11.4883188 4.05534367,11.6161167 4.15,11.71 L6.31,13.87 C6.40538829,13.9657197 6.53486642,14.019669 6.67,14.02 C6.79773933,14.0077793 6.91589034,13.9469136 7,13.85 L11.33,9.52 C11.4246563,9.4261167 11.4778992,9.29831877 11.4778992,9.165 C11.4778992,9.03168123 11.4246563,8.9038833 11.33,8.81 C11.1382234,8.63214141 10.8417766,8.63214141 10.65,8.81 Z" />
      </g>
    </BaseSvgIcon>
  )
}

export default Survey
